import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TTransactionsStore,
	TTransactionsResponsePayload,
	TTransactionsRequestPayload,
} from './types';
// ==========================================:
export const initialState: TTransactionsStore = {
	transactions: null,
	transactionsLoader: false,
};

// ==========================================:
const transactions = createSlice({
	name: '@@transactions',
	initialState,
	reducers: {
		getTransactionsRequest: (
			state: TTransactionsStore,
			action: PayloadAction<TTransactionsRequestPayload>,
		) => {
			const transactionsRequestState = state;
			transactionsRequestState.transactionsLoader = true;
		},
		getTransactionsSuccess: (
			state: TTransactionsStore,
			action: PayloadAction<TTransactionsResponsePayload>,
		) => {
			const { payload } = action;
			const transactionsSuccessState = state;
			transactionsSuccessState.transactions = payload;
			transactionsSuccessState.transactionsLoader = false;
		},

		assetsInitState: () => initialState,
	},
});

export default transactions.reducer;
export const { getTransactionsRequest, getTransactionsSuccess, assetsInitState } =
	transactions.actions;
